import { makeStyles } from '@material-ui/core/styles'
import React from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'
import { matchPath, useLocation } from 'react-router'

import SecondaryNav from './SecondaryNav'

const useStyles = makeStyles(theme => ({
  root: ({ isMobile }) => ({
    height: '100%',
    paddingTop: 54,
    [theme.breakpoints.up('mobile')]: {
      paddingTop: 52,
    },
  }),
}))

const SecondaryNavLayout = ({ routes, defaultRoute, ...props }) => {
  const classes = useStyles()
  const links = getNavLinks(routes)
  const { pathname } = useLocation()

  const currentRoute = routes.find(route => matchPath(pathname, route))
  const pageTitle =
    currentRoute && (currentRoute.title || currentRoute.navLabel)

  if (links.length > 0) {
    return (
      <>
        <SecondaryNav links={links} title={pageTitle} {...props} />
        <div className={classes.root}>
          <Routing {...{ defaultRoute, routes }} />
        </div>
      </>
    )
  } else {
    return <Routing {...{ defaultRoute, routes }} />
  }
}

const Routing = ({ routes, defaultRoute = routes[0].path }) => {
  return (
    <Switch>
      {routes.map((route, idx) => (
        <Route key={idx} {...route} />
      ))}
      <Redirect to={defaultRoute} />
    </Switch>
  )
}

const getNavLinks = routes =>
  routes
    .filter(i => i.navLabel)
    .map(({ exact, navLabel, path }) => ({
      exact,
      text: navLabel,
      to: path,
    }))

export default SecondaryNavLayout
